import {
  callApiAsync,
  getWalletCollectionHistory,
  uploadWalletCollectionRecaudo,
  getWalletCollectionClients,
  getWalletCollectionInvoices,
  downloadWalletCollectionHistory,
} from "../../../services/apiService";
 
export const getWalletCollectionHistoryDATA = async (
  year,
  month,
  page,
  pageSize,
  setData,
  setTotal,
  setPage,
  clientId = null,
  invoiceCode = null,
  lineIds = [],
  userId
) => {
  if (!year || !month) return;

  await callApiAsync(
    () => getWalletCollectionHistory(year, month, page, pageSize, clientId, invoiceCode, lineIds, userId),
    (resp) => {
      const data = resp?.data ?? resp;

      setData(data.items || []);
      setTotal(data.total || 0);
      setPage(data.page || page);
    }
  );
};

export const getWalletCollectionClientsDATA = async (setClientOptions, userId) => {
  await callApiAsync(
    () => getWalletCollectionClients(userId),
    (resp) => {
      const data = resp?.data ?? resp;
      setClientOptions(data.items || []);
    }
  );
};

export const getWalletCollectionInvoicesDATA = async (year, month, setInvoiceOptions, lineIds = [], userId) => {
  await callApiAsync(
    () => getWalletCollectionInvoices(year, month, lineIds, userId),
    (resp) => {
      const data = resp?.data ?? resp;
      setInvoiceOptions(data.items || []);
    }
  );
};

export const postWalletCollectionUploadDATA = async (
  payload,
  onSuccess,
  onError
) => {
  const fd = new FormData();
  fd.append("year", payload.year);
  fd.append("month", payload.month);

  // multer espera name="recaudo"
  if (payload?.files?.recaudo) fd.append("recaudo", payload.files.recaudo);

  // --- Validación recaudo (comentado: descomentar para depurar en local/producción) ---
  // const file = payload?.files?.recaudo;
  // console.log("[RECAUDO] Payload:", { year: payload.year, month: payload.month, hasRecaudoFile: !!file, fileName: file?.name, fileSize: file?.size, fileType: file?.type });
  // console.log("[RECAUDO] FormData keys:", [...fd.keys()]);

  try {
    const response = await uploadWalletCollectionRecaudo(fd, payload.userId);
    const data = response?.data ?? response;
    // console.log("[RECAUDO] Respuesta OK:", { status: response?.status, dataKeys: data ? Object.keys(data) : [], stats: data?.stats });
    if (onSuccess) {
      onSuccess(data);
    }
  } catch (err) {
    // Resumen para producción: siempre se registra para ver qué llega cuando hay 502/CORS/Network Error
    console.warn("[RECAUDO] Error upload (resumen):", {
      code: err?.code,
      message: err?.message,
      hasResponse: !!err?.response,
      status: err?.response?.status,
      responseData: err?.response?.data
    });
    console.error("Error en postWalletCollectionUploadDATA:", err);
    if (onError) {
      onError(err);
    } else {
      console.error("Error no manejado:", err);
    }
  }
};

export const downloadWalletCollectionHistoryDATA = async (
  year,
  month,
  clientId = null,
  invoiceCode = null,
  lineIds = [],
  userId
) => {
  try {
    const response = await downloadWalletCollectionHistory(year, month, clientId, invoiceCode, lineIds, userId);
    const blob = new Blob([response.data], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
    });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    const monthName = month < 10 ? `0${month}` : month;
    link.download = `Historial_Dias_Cartera_${monthName}_${year}.xlsx`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
  } catch (err) {
    console.error("Error descargando historial:", err);
    throw err;
  }
};
